import React from "react";

const NotesIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_9075_111551)">
        <path
          d="M12.4445 13.3327H2.66672V3.5549H8.54228L9.43117 2.66602H2.66672C2.43097 2.66602 2.20488 2.75967 2.03818 2.92637C1.87148 3.09306 1.77783 3.31916 1.77783 3.5549V13.3327C1.77783 13.5684 1.87148 13.7945 2.03818 13.9612C2.20488 14.1279 2.43097 14.2216 2.66672 14.2216H12.4445C12.6802 14.2216 12.9063 14.1279 13.073 13.9612C13.2397 13.7945 13.3334 13.5684 13.3334 13.3327V6.66602L12.4445 7.5549V13.3327Z"
          fill="#334155"
        />
        <path
          d="M14.9021 2.59575L13.4043 1.09797C13.3378 1.03132 13.2589 0.978434 13.1719 0.942351C13.085 0.906269 12.9918 0.887695 12.8977 0.887695C12.8035 0.887695 12.7103 0.906269 12.6234 0.942351C12.5364 0.978434 12.4575 1.03132 12.391 1.09797L6.29765 7.22686L5.80432 9.36464C5.7833 9.46826 5.78551 9.57526 5.81079 9.67793C5.83606 9.7806 5.88378 9.87639 5.95051 9.95842C6.01723 10.0404 6.1013 10.1067 6.19668 10.1523C6.29205 10.198 6.39636 10.2219 6.50209 10.2224C6.55674 10.2284 6.61189 10.2284 6.66654 10.2224L8.8221 9.74686L14.9021 3.60908C14.9687 3.54261 15.0216 3.46364 15.0577 3.3767C15.0938 3.28976 15.1124 3.19655 15.1124 3.10241C15.1124 3.00828 15.0938 2.91507 15.0577 2.82813C15.0216 2.74119 14.9687 2.66222 14.9021 2.59575ZM8.35987 8.92464L6.73321 9.28464L7.11098 7.6713L11.6977 3.05353L12.951 4.30686L8.35987 8.92464ZM13.4532 3.80464L12.1999 2.5513L12.8888 1.84908L14.151 3.1113L13.4532 3.80464Z"
          fill="#334155"
        />
      </g>
      <defs>
        <clipPath id="clip0_9075_111551">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NotesIcon;
